import { getItemImage, getLocalizedString, getRating, getRelatedValue } from '../../../../http/driveApiGateway/helper'
import Stars from '../../Stars'
import React from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

const GreyMainHotel = function ({ item, relatedItems, propertyImage, infoValues }) {
  const imageUrl = propertyImage ?? getItemImage(item, relatedItems, '320')
  return (
    <div className="grey-main-hotel">
      <div className="hotel-basic-info">
        <div>
          <span
            className="hotel-image"
            style={{ backgroundImage: 'url(' + imageUrl + ')' }}
          />
        </div>
        <div className="hotel-basic-info-name-loc">
          <div>{getLocalizedString(item, 'name')}</div>
          <div>
            {getRelatedValue(item, relatedItems, 'city')}
            &nbsp;|&nbsp;
            {getRelatedValue(item, relatedItems, 'country')}
          </div>
        </div>
      </div>
      <div>
        <Stars count={getRating(item)} type={'black'}></Stars>
      </div>
      {infoValues && infoValues.map((i) => {
        return (
          <div key={i.header}>
            <div className="ghm-info-header">{i.header}</div>
            <div className="ghm-info-value">{i.value}</div>
          </div>
        )
      })}
    </div>
  )
}

GreyMainHotel.propTypes = {
  item: PropTypes.object.isRequired,
  relatedItems: PropTypes.array.isRequired,
  propertyImage: PropTypes.string,
  infoValues: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }))
}

export default GreyMainHotel
